import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, errMsg } from "@/lib/api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [users, setUsers] = useState([]);
  const [userId, setUserIdState] = useState(localStorage.getItem("vig_user") || "u_public");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [version, setVersion] = useState(0);
  const [selectedOpp, setSelectedOppState] = useState(localStorage.getItem("vig_opp") || "opp_green_ind");
  const [tour, setTour] = useState({ active: false, step: 0, steps: [], startedAt: null });
  const [assistantOpen, setAssistantOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const [u, b] = await Promise.all([api.get("/users"), api.get("/bootstrap")]);
      setUsers(u.data);
      setData(b.data);
    } catch (e) {
      setError(errMsg(e));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, version]);

  const setUserId = useCallback((id) => {
    localStorage.setItem("vig_user", id);
    setUserIdState(id);
  }, []);
  const setSelectedOpp = useCallback((id) => {
    if (!id) return;
    localStorage.setItem("vig_opp", id);
    setSelectedOppState(id);
  }, []);
  const refresh = useCallback(() => setVersion((v) => v + 1), []);

  const value = useMemo(() => {
    const user = users.find((u) => u.id === userId) || users.find((u) => u.id === "u_public");
    const by = (k) => Object.fromEntries((data?.[k] || []).map((x) => [x.id, x]));
    return {
      users, user, userId, setUserId, data, error, refresh, version,
      can: (p) => !!user?.perms?.includes(p),
      selectedOpp, setSelectedOpp,
      themes: by("themes"), initiatives: by("initiatives"), opps: by("opportunities"), sources: by("sources"),
      tour, setTour, assistantOpen, setAssistantOpen,
    };
  }, [users, userId, setUserId, data, error, refresh, version, selectedOpp, setSelectedOpp, tour, assistantOpen]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
